import { siteMapNavItem } from '../types/siteMap'
import start from './start'
import noir from './noir'

const siteMaps = {
  start,
  noir,
}

const maps = [...start, ...noir].map((item: siteMapNavItem) => {
  return {
    ...item,
    // id: `${item.id}-${item.path}`
  }
})

export default maps

export { siteMaps }
